export var DIDService;
(function (DIDService) {
    DIDService["DATASTORE"] = "DataStore";
})(DIDService || (DIDService = {}));
export var StorageLocation;
(function (StorageLocation) {
    StorageLocation["Store"] = "IdentityStore";
})(StorageLocation || (StorageLocation = {}));
